import { Stack, Text } from "@fluentui/react";
import Layout from "../../../styles/Layout.styles";
import Style from "./AddClient.style";
import { Divider, mergeClasses } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const ClientViewAccount = (props) => {
  const { viewData } = props;
  const layout = Layout();
  const { t } = useTranslation();
  const style = Style();

  return (
    <>
      <h2 className={mergeClasses(style.headerTitle, layout.padding1_5x)}>
        {t("company_contact_person")}
      </h2>
      <Stack className={mergeClasses(style.subDetails, layout.mb_2)}>
        <Stack
          className={mergeClasses(style.fieldsection, layout.align_self_start)}
        >
          <Text className={mergeClasses(layout.detailsSplite)}>
            <Text className={style.textElement}>{t("name")}</Text>
            {`${viewData?.data?.contactPerson?.firstName}`}
          </Text>
          <Divider className={layout.padding1_5x} />
          <Text className={mergeClasses(layout.detailsSplite)}>
            <Text className={style.textElement}>{t("phone_number")}</Text>(
            {`${viewData?.data?.contactPerson?.phonePrefix}`}){" "}
            {`${viewData?.data?.contactPerson?.phoneNumber}`}
          </Text>
          <Divider className={layout.padding1_5x} />
          <Text className={mergeClasses(layout.detailsSplite)}>
            <Text className={style.textElement}>{t("department")}</Text>
            {`${viewData?.data?.contactPerson?.department}`}
          </Text>
        </Stack>

        <Stack
          className={mergeClasses(style.fieldsection, layout.align_self_start)}
        >
          <Text className={mergeClasses(layout.detailsSplite)}>
            <Text className={style.textElement}>{t("email_address")}</Text>
            {`${viewData?.data?.contactPerson?.email}`}
          </Text>

          <Divider className={layout.padding1_5x} />
          <Text className={mergeClasses(layout.detailsSplite)}>
            <Text className={style.textElement}>{t("timezone")}</Text>
            {`${viewData?.data?.contactPerson?.timezone}`}
          </Text>
          <Divider className={layout.padding1_5x} />
        </Stack>
      </Stack>
    </>
  );
};

export default ClientViewAccount;
